(function () {
  function getTheme() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function updateButtons(theme) {
    document.querySelectorAll('[data-theme-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
    });
  }

  // swaps the .glb loaded into any theme-aware <model-viewer> (e.g. the
  // 8-ball tee: white model rotates in light theme, black in dark theme)
  function updateThemeAwareModels(theme) {
    document.querySelectorAll('model-viewer.theme-aware-model').forEach(function (viewer) {
      var src = theme === 'light' ? viewer.dataset.srcLight : viewer.dataset.srcDark;
      if (src && viewer.getAttribute('src') !== src) {
        viewer.setAttribute('src', src);
      }
    });
  }

  function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem('theme', theme);
    } catch (e) {}
    updateButtons(theme);
    updateThemeAwareModels(theme);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    setTheme(getTheme() === 'light' ? 'dark' : 'light');
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons(getTheme());
    updateThemeAwareModels(getTheme());
  });
})();
